import { i18n } from 'i18next';
import moment from 'moment/moment';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { Registration } from '../types/registrationTypes';

export const getFooter = (t: i18n['t'], registration: Registration): TDocumentDefinitions['footer'] => {
  const row2 = [
    {
      text: 'Thermia AB',
      fontSize: 6,
      bold: true,
      margin: [0, -2, 0, 0]
    },
    {
      text: '+46 570 813 00',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },
    {
      text: 'Org. SE556269-6483',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    }
  ];

  const row3 = [
    {
      text: 'Box 950',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },

    {
      text: 'Email: info@thermia.com',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },
    {
      text: 'Vat. SE556269648301',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    }
  ];

  const row4 = [
    {
      text: '671 29 Arvika',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },
    {
      text: 'www.thermia.com',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },

    {
      text: '',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    }
  ];

  const row5 = [
    {
      text: 'Sweden',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },
    {
      text: '',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    },

    {
      text: '',
      fontSize: 6,
      margin: [0, -2, 0, 0]
    }
  ];

  return {
    columns: [
      {
        table: {
          body: [row2, row3, row4, row5]
        },
        layout: 'headerLineOnly',
        margin: [40, 0, 40, 0]
      },
      [
        {
          text: `ID: ${registration.id}`,
          fontSize: 6,
          alignment: 'right',
          margin: [0, 0, 20, 0]
        },
        {
          text: `${t('registrations.general.printedDate')}: ${moment().format('YYYY-MM-DD HH:mm')}`,
          alignment: 'right',
          margin: [0, 0, 20, 0],
          fontSize: 6
        }
      ]
    ]
  };
};
